// extracted by mini-css-extract-plugin
module.exports = {"simpleNav":"SimpleNav_simpleNav__1_pCZ","simpleNav__backBtn":"SimpleNav_simpleNav__backBtn__2tnKC","simpleNav__logo":"SimpleNav_simpleNav__logo__eRsmq"};